'use strict';

(function initializeAdventureState(root) {
    const STORAGE_KEY = 'dnd-next-level:adventure-current';
    const REQUEST_FIELDS = new Set(['setting', 'tier', 'hookTable', 'encounterObjectiveType']);
    const RESULT_FIELDS = new Set([
        'settingValue', 'settingLabel', 'settingDescription', 'tierValue', 'tierLabel', 'situation',
        'drawInHookTable', 'drawInHook', 'encounterObjectiveType', 'encounterObjectiveTitle',
        'encounterObjectiveDescription', 'climax',
    ]);
    const REQUIRED_RESULT_TEXT = [
        'tierValue', 'tierLabel', 'situation', 'drawInHookTable', 'drawInHook', 'encounterObjectiveType',
        'encounterObjectiveTitle', 'encounterObjectiveDescription', 'climax',
    ];

    const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
    const hasOnlyKeys = (value, fields) => Object.keys(value).every(key => fields.has(key));
    const safeText = (value, max = 5000) => typeof value === 'string'
        && value.trim().length > 0
        && value.length <= max;
    const enumValue = value => safeText(value, 100) && /^[A-Z][A-Z0-9_]*$/.test(value);
    const optionalEnum = value => value == null || enumValue(value);

    const state = {
        storageKey: () => STORAGE_KEY,

        validate(saved) {
            if (!isRecord(saved) || !isRecord(saved.request) || !isRecord(saved.result)) return false;
            if (!hasOnlyKeys(saved.request, REQUEST_FIELDS) || !hasOnlyKeys(saved.result, RESULT_FIELDS)) return false;
            if (!enumValue(saved.request.tier)
                || !optionalEnum(saved.request.setting)
                || !optionalEnum(saved.request.hookTable)
                || !optionalEnum(saved.request.encounterObjectiveType)) return false;
            if (!REQUIRED_RESULT_TEXT.every(field => safeText(saved.result[field]))) return false;

            const setting = [
                saved.result.settingValue,
                saved.result.settingLabel,
                saved.result.settingDescription,
            ];
            return setting.every(value => value == null)
                || (enumValue(setting[0]) && safeText(setting[1]) && safeText(setting[2]));
        },

        parse(raw) {
            if (typeof raw !== 'string') return null;
            try {
                const saved = JSON.parse(raw);
                return state.validate(saved) ? saved : null;
            } catch (_error) {
                return null;
            }
        },

        clone(saved) {
            return JSON.parse(JSON.stringify(saved));
        },

        read(storage) {
            if (!storage) return null;
            try {
                return state.parse(storage.getItem(STORAGE_KEY));
            } catch (_error) {
                return null;
            }
        },

        persist(storage, saved) {
            if (!storage || !state.validate(saved)) return false;
            try {
                storage.setItem(STORAGE_KEY, JSON.stringify(saved));
                return true;
            } catch (_error) {
                return false;
            }
        },
    };

    root.dndNextLevel = root.dndNextLevel || {};
    root.dndNextLevel.adventureState = state;
})(window);
